import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { Localidad } from './entity-localidades.model';

export const entityLocalidadesAdapter: EntityAdapter<Localidad> =
  createEntityAdapter<Localidad>({
    selectId: (model) => model.id,
    sortComparer: (a: Localidad, b: Localidad): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityLocalidadesState extends EntityState<Localidad> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityLocalidadesState =
  entityLocalidadesAdapter.getInitialState({
    isLoading: false,
    error: null
  });
